import WmsLayer from './WmsLayer';
import { pzgikAttribution } from './attribution';

export default class StudiumLayer extends WmsLayer {
    static ID = 'studium';
    static DESCRIPTION = 'Studium uwarunkowań i kierunków zagospodarowania przestrzennego';
    static MIN_ZOOM = 16;

    getWmsConfig() {
        return {
            url: 'https://mapy.geoportal.gov.pl/wss/ext/KrajowaIntegracjaStudiumKierunkowZagospodarowaniaPrzestrzennego',
            params: {
                LAYERS: 'studium',
                FORMAT: 'image/png',
                TRANSPARENT: 'true',
                VERSION: '1.1.1'
            },
            opacity: 0.65,
            attribution: pzgikAttribution('studium uwarunkowań i kierunków zagospodarowania przestrzennego')
        };
    }
}
